import type { User } from "@/lib/types/user";

// ============================================================================
// USER DETAILS MODAL — PURE HELPERS
// ============================================================================

export function formatCentralDate(value: string | null | undefined): string {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  // WTC operates in Central time (WTC_DEFAULT_TIMEZONE) — render in America/Chicago.
  return new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Chicago",
    dateStyle: "medium",
    timeStyle: "short",
  }).format(date);
}

export function userDisplayName(user: User | undefined | null): string {
  if (!user) return "User";
  const full = [user.first_name, user.last_name]
    .filter(Boolean)
    .join(" ")
    .trim();
  return full || user.name || user.email || "User";
}
